export default {
  declaration: {
    label: 'À quelle valeur estimez-vous l\'ensemble des biens qui seront transportés dans le cadre de votre déménagement ?',
    options: {
      5000: 'Moins de 5 000',
      10000: 'Entre 5 000 et 10 000',
      15000: 'Entre 10 000 et 15 000',
      20000: 'Supérieur à 15 000',
    },
    moreLabel: 'Précisez cette valeur :',
  },
  additional: {
    label: 'Souhaitez-vous souscrire une assurance tout risque complémentaire ?',
  },
};
